/**
 * What a failed write reported, and the two credit refusals every credit write can meet — the
 * booking screen's session panel, its Rozliczenia tab and the client card's acts — worded once.
 *
 * Pure: no React, no DOM, no query hook, no i18next.
 */

/** What a failed write reported: its status and code, or `null` when no answer came back. */
export interface FailedWrite {
  readonly status: number;
  readonly code: string | undefined;
  /** The request field the refusal names, where the server names one. */
  readonly field?: string | undefined;
}

/**
 * The two credit refusals every credit write can meet — the session panel's forgiveness and the
 * Rozliczenia tab's four acts — worded once: credits switched off since the screen was read, and a
 * request id already spent on another entry.
 */
export const CREDIT_REFUSAL_KEYS = {
  credits_disabled: `web:booking.refusal.credits_disabled`,
  idempotency_key_reused: `web:booking.refusal.idempotency_key_reused`,
} as const;
